import Toast from './Toast';

const ToastContainer = ({ toasts, onRemoveToast }) => {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast, index) => {
        const duration = typeof toast.duration === 'number' ? toast.duration : 5000;
        return (
          <Toast
            key={toast.id}
            message={toast.message}
            type={toast.type}
            duration={duration}
            onClose={() => onRemoveToast(toast.id)}
            isVisible={true}
            style={{
              top: `${20 + index * 70}px`
            }}
          />
        );
      })}
    </div>
  );
};

export default ToastContainer;
